import { createDragDropManager } from "dnd-core";
import { HTML5Backend } from "react-dnd-html5-backend";

/** Singleton manager — React StrictMode remounts break HTML5Backend otherwise. */
let sharedManager: ReturnType<typeof createDragDropManager> | null = null;

export function getSharedDndManager() {
  if (typeof window === "undefined") return null;
  if (!sharedManager) {
    sharedManager = createDragDropManager(HTML5Backend as any, window);
  }
  return sharedManager;
}
